import { useI18nPreviewContext } from '@src/quince-site-common/src/contexts/i18n-preview-context/i18n-preview-context'

export default function withI18nGate<P extends object>(Component: React.ComponentType<P>, showChildren = false) {
  return function WithI18nGate(props: P & { children?: React.ReactNode }) {
    const isI18nPreviewEnabled = useI18nPreviewContext()
    if (!isI18nPreviewEnabled) return showChildren ? props.children : null
    return <Component {...props} />
  }
}